import React, { Component } from 'react';
import Token from './token';
import cx from 'classnames';

export default class TokenEdit extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { values } = this.props;
        return (
            <div className={cx('bootstrap-typeahead', 'clearfix', 'open')}>
                <div className={cx('bootstrap-tokenizer', 'clearfix', 'form-control')}>
                    {values.map(this.renderToken.bind(this))}
                </div>
            </div>
        );
    }

    renderToken(option, idx) {
        const { onRemove } = this.props;
        const onRemoveWrapped = () => onRemove(option);
        //const labelKey = option.key
        return (
            <Token
                disabled={false} //{disabled}
                key={option.key}
                onRemove={onRemoveWrapped}
            >
                {option.value}
            </Token>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/token-edit.js